import { useCallback } from 'react';

import { useInterfaceLanguage } from '@/shared/i18n';
import { formatInterfaceCurrency } from '@/shared/i18n/formatLocale';

export const usePriceFormatting = () => {
  const { locale } = useInterfaceLanguage();
  const formatPrice = useCallback(
    (amount: number, currency: string) => {
      return formatInterfaceCurrency(locale, amount, currency);
    },
    [locale],
  );

  const calculateVATPercentage = useCallback((taxAmount: number | undefined, totalAmount: number) => {
    if (!taxAmount || taxAmount === 0) return '0%';
    const subtotal = totalAmount - taxAmount;
    if (subtotal === 0) return '0%';
    const percentage = (taxAmount / subtotal) * 100;
    return `${Math.round(percentage)}%`;
  }, []);

  return { calculateVATPercentage, formatPrice };
};
